import axios from 'axios';  

const axiosInstance = axios.create({  
    baseURL: 'https://backend.mercylandgroup.com/api', // Adjust your base URL if necessary  
});  

// Interceptor to add token to headers for every request  
axiosInstance.interceptors.request.use(  
    (config) => {  
        const token = localStorage.getItem('token');  
        if (token) {  
            config.headers['Authorization'] = `Bearer ${token}`;  
        }  
        return config;  
    },  
    (error) => {  
        return Promise.reject(error);  
    }  
);  

export default axiosInstance;